import { FoaPart, Regulation } from "../../../../../autogen/bff-api";

export type EspdRequirement =
  | { required: "unknown" }
  | { required: true; value: string }
  | { required: false; value: string };

// Mirrors the EEA tiers in the BFF's ProcurementThresholds.kt — keep in sync. FOA counts del
// III/IV; forsyningsforskriften counts del II and up, having no national tier (§ 5-2).
const ESPD_REQUIRED_PARTS: Record<Regulation, ReadonlySet<FoaPart>> = {
  [Regulation.Foa]: new Set([FoaPart.PartIii, FoaPart.PartIv]),
  [Regulation.Forsyningsforskriften]: new Set([FoaPart.PartIi, FoaPart.PartIii, FoaPart.PartIv]),
  [Regulation.Konsesjonskontraktforskriften]: new Set(),
};

// foaPart is server-derived from estimated value + contract nature (FoaPartClassifier), so
// this gate stays consistent with the part rendered elsewhere in the wizard.
export function computeEspdRequirement(
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
  estimatedValueNok: number | null | undefined,
): EspdRequirement {
  if (regulation == null || foaPart == null || estimatedValueNok == null) {
    return { required: "unknown" };
  }
  const value = formatNok(estimatedValueNok);
  return { required: ESPD_REQUIRED_PARTS[regulation].has(foaPart), value };
}

function formatNok(value: number): string {
  return new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
  }).format(value);
}
